import { CommonPlayerEventParams } from '../useCommonPlayerEventParams';
import { useTriggerOnPlayerEvent } from '../useTriggerOnPlayerEvent';

export const useTriggerOnBufferingEnd = (params: CommonPlayerEventParams) => {
    return useTriggerOnPlayerEvent(params, 'PLAYBACK_BUFFERING_FINISHED');
};
